module.exports = __webpack_public_path__ + "img/PerformanceManager_einfarbig_RGB.92c6c369.svg";